import { Ban } from "lucide-react";
import { format } from "date-fns";

interface DeletedMessageProps {
  createdAt: string;
  isFromAgent: boolean;
  deletedForEveryone?: boolean;
}

export function DeletedMessage({ createdAt, isFromAgent, deletedForEveryone = true }: DeletedMessageProps) {
  const formatMessageTime = (dateStr: string) => {
    const date = new Date(dateStr);
    return format(date, "HH:mm");
  };

  return (
    <div
      className={`flex items-end gap-1.5 ${
        isFromAgent ? "justify-start" : "justify-end"
      }`}
    >
      <div
        className={`max-w-[75%] px-4 py-2.5 rounded-2xl border border-dashed ${
          isFromAgent
            ? "bg-muted/30 border-muted-foreground/20"
            : "bg-muted/20 border-muted-foreground/20"
        }`}
      >
        <div className="flex items-center gap-2 text-muted-foreground">
          <Ban size={14} className="shrink-0" />
          <span className="text-sm italic">
            {deletedForEveryone 
              ? "Ce message a été supprimé" 
              : "Vous avez supprimé ce message"}
          </span>
        </div>
        <div
          className={`flex items-center gap-1 mt-1 ${
            isFromAgent ? "justify-start" : "justify-end"
          }`}
        >
          <span className="text-[10px] text-muted-foreground/60">
            {formatMessageTime(createdAt)}
          </span>
        </div>
      </div>
    </div>
  );
}
